<template>
  <div class="resultFixLine">
    <div class="wrapper">
      <div class="flex">
        <div class="wrapper-l">
          <div class="text-wrap">
            <img alt="" src="/assets/images/builds/clock-ic.svg"/>
            <p class="fs-14">
              <strong>{{ trans['delivery_date'] }}</strong> {{ deliveryDate }}
            </p>
          </div>
          <div class="text-wrap">
            <img alt="" src="/assets/images/builds/rocket-ic.svg"/>
            <p class="fs-14">
              <strong>{{ trans['free_shipping'] }}</strong> Europe*
            </p>
          </div>
        </div>
        <div class="wrapper-r">
          <div class="stepLine">
            <p class="text">{{ trans['step'] }} <span>{{ activeStepNumber }}</span> {{ trans['of'] }} 5</p>
            <ul :class="`step-${activeStepNumber}`">
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div class="totalText">
            <p class="total-text-wrap">
              <span class="small fs-12" v-if="showFromValue">from</span>
              <span class="fs-24 bold">{{ buildPrice }}</span>
            </p>
            <button
              v-if="hasExtra"
              class="btn btn-arr"
              type="button"
              @click.prevent="toggleExtraOptions"
            >
              <span v-if="!extraOptionsVisibility" class="span-show">
                {{ trans['show_extra'] }}
              </span>
              <span v-if="extraOptionsVisibility" class="span-hide">
                {{ trans['hide_extra'] }}
              </span>
              <svg
                fill="none"
                height="12"
                viewBox="0 0 8 12"
                width="8"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.999999 11.4531L6 6.45313L1 1.45312"
                  stroke="black"
                  stroke-width="1.5"
                />
              </svg>
            </button>
          </div>
          <a
            :class="addToBagBtnClass"
            :disabled="addToBagDisabled"
            class="btn btn-green"
            @click="addToBag"
          >
            {{ trans['add_to_bag'] }}
          </a>
        </div>

        <transition name="side">
          <ul v-if="extraOptionsVisibility" class="extraOption">
            <li
              v-for="item in extra"
              :key="item.id">{{ item.title }}
              <span class="price">{{ $crConverter(item.price / 100, 'EUR', '%s +%v') }}</span>
            </li>
          </ul>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "InfoFooter",
  props: ['trans', 'customBuild'],
  data() {
    return {
      extraOptionsVisibility: false,
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
      lang: 'en'
    }
  },
  mounted() {
    this.lang = this.getMeta('selected-language') || 'en';
  },
  computed: {
    ...mapGetters({
      steps: 'build/stepList',
      selectedPaymentOption: 'build/selectedPaymentOption',
      extra: 'build/extra',
      customColor: 'build/customColor',
      motoStyle: 'build/motoStyle',
      vatConfirm: 'build/vatConfirm',
      preselected: 'build/preselected',
      getAuthUser: "getAuthUser",
    }),
    showFromValue() {
      return (!this.hasModelStage || !this.isCompletedModelStage) && !this.customBuild
    },
    hasModelStage() {
      return this.preselected && this.preselected.model
    },
    isCompletedModelStage() {
      return this.hasModelStage && this.preselected.model.completed
    },
    addToBagDisabled() {
      return (!(this.preselected?.size?.completed || false) || !this.vatConfirm) && !this.customBuild
    },
    build() {
      return this.preselected?.build || null
    },
    model() {
      return this.preselected?.model?.selected || null
    },
    lastStep() {
      let max = 1
      for (let key of Object.keys(this.steps)) {
        if (key > max) {
          max = key
        }
      }
      return max - 1
    },
    deliveryDate() {
      const defaultDate = this.$moment().add(3, 'month').format('MMMM YYYY')

      if (this.build) {
        let deliveryDate = this.build?.delivery_date;

        if (deliveryDate) {
          return this.months[deliveryDate.month] + ' ' + deliveryDate.year
        } else if (this.model) {
          return this.model?.delivery_info || defaultDate
        }
      }

      return defaultDate
    },
    isDisabled() {
      return this.addToBagDisabled
    },
    addToBagBtnClass() {
      return {
        disabled: this.isDisabled
      }
    },
    hasExtra() {
      return this.extra.length > 0
    },
    validPresaleDate() {
      let presaleRule = false
      if (this.build['pre_sale_start'] && this.build['pre_sale_end']) {
        presaleRule = this.$moment(this.$moment.now()).isBetween(this.build['pre_sale_start'], this.build['pre_sale_end'])
      } else {
        return false
      }
      return presaleRule
    },
    activeStepNumber() {
      if (this.customBuild) {
        return 5
      }

      if (this.preselected && this.preselected.model) {
        if (this.preselected.model.active) {
          return 1
        } else if (this.preselected.title.active) {
          return 2
        } else if (this.preselected.color.active) {
          return 3
        } else if (this.preselected.size.active || this.preselected.size.completed) {
          return 4
        }
      }

      return 1
    },
    fullPriceClean() {
      if (this.build) {
        return this.build.prices.price_for_eu
      }

      return null
    },
    preSalePriceClean() {
      return this.build['prices']['ex_price_tax_base']
    },
    buildPriceWithoutExtra() {
      if (this.build !== null) {
        let cost = 0
        if (this.selectedPaymentOption === 'full') {
          if (!this.validPresaleDate) {
            cost = this.fullPriceClean
          } else {
            cost = this.preSalePriceClean
          }
        } else {
          cost = this.build['prices']['res_price_for_eu']
        }
        return cost
      }

      return null
    },
    buildPrice() {
      if (this.customBuild) {
        return this.$crConverter(this.customBuild.prices.price_for_eu / 100, "EUR")
      }

      if (this.build !== null) {
        let cost
        if (this.showFromValue && this.preselected?.model?.selected) {
          cost = this.preselected.model.selected.price_min * 100
        } else {
          cost = this.buildPriceWithoutExtra
        }
        this.extra.map(item => {
          cost += item.price
        })
        return this.$crConverter(cost / 100, 'EUR');
      }

      return null;
    },
  },
  methods: {
    checkActivated() {
      return new Promise((resolve) => {
        this.$store.dispatch('checkout/checkActivated').then(response => {
          resolve(response.data.data.status)
        }).catch(err => {
          console.log("Error checking user activating", err)
          resolve(false)
        })
      })
    },
    getMeta(metaName) {
      const metas = document.getElementsByTagName('meta');

      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
          return metas[i].getAttribute('content');
        }
      }

      return null;
    },
    toggleExtraOptions() {
      this.extraOptionsVisibility = !this.extraOptionsVisibility
    },
    addToBagAndRedirect() {
      this.$store.dispatch('build/addToBasket', {
        path: this.$path,
        build: this.customBuild || this.build,
        purchase_type: this.selectedPaymentOption,
        moto_style: this.motoStyle,
        extra: this.extra.map(item => {
          return item.id
        }),
        custom_color: this.customColor
      }).then(() => {
        location.href = `/${this.lang}/bag`
      })
    },
    addToBag() {
      if (!this.isDisabled) {
        if (!this.getAuthUser) {
          this.addToBagAndRedirect()
        } else {
          if (this.getAuthUser.email_verified_at) {
            this.addToBagAndRedirect()
          } else {
            this.$root.$emit("showNotActivatedModal")
          }
        }
      }
    }
  },
  watch: {
    hasExtra(value) {
      if (!value) {
        this.extraOptionsVisibility = false
      }
    }
  }
}
</script>
